<div class="column resultado-consulta-container px-1 px-sm-2 px-md-3 px-xl-5 mb-3">

  <app-header-top [cabecalho]="cabecalho" [titulo]="title"></app-header-top>

  <div class="d-flex flex-column flex-lg-row responsive-content">
    <div class="w-100">
      <div class="row responsive-column">
        <div class="col-12 d-flex flex-lg-row">
          <div class="font-weight-bold">Nome Fantasia:</div>
          <div class="format-compact px-1">{{cabecalho?.razaoSocialUnidade}}</div>
        </div>
        <div class="col-12 d-flex flex-lg-row">
          <div class="font-weight-bold">CPF/CNPJ:</div>
          <div class="format-compact px-1">{{cabecalho?.documentoUnidade}}</div>
        </div>
        <div class="col-12 d-flex flex-lg-row">
          <div class="font-weight-bold">Endereço:</div>
          <div class="format-compact px-1">{{cabecalho?.enderecoUnidade}}</div>
        </div>
      </div>
    </div>
    <div class="w-100">
      <div class="row px-lg-6 responsive-column">
        <div class="col-12 d-flex flex-lg-row">
          <div class="font-weight-bold">Data da Realização da Vistoria:</div>
          <div class="format-compact px-1">{{cabecalho?.dataVst.value}} {{cabecalho?.horaVst.value}}</div>
        </div>
        <div class="col-12 d-flex flex-lg-row">
          <div class="font-weight-bold">Telefone:</div>
          <div class="format-compact px-1">{{cabecalho?.telefoneUnidade}}</div>
        </div>
        <div *ngIf="cabecalho?.enderecoLaudo.cidade != '' && cabecalho?.enderecoLaudo.cidade != null " class="col-12 d-flex flex-lg-row">
          <div class="font-weight-bold">Local da vistoria:</div>
          <div class="format-compact px-1"> {{cabecalho?.enderecoLaudo.cidade}} / {{cabecalho?.enderecoLaudo.estado}} <strong *ngIf="cabecalho?.enderecoLaudo.lat == 0 " >*</strong></div>
        </div>
      </div>
    </div>
    <div class="w-100" *ngIf="parecer">
      <div class="col-12 my-1">
        <div class="d-lg-flex justify-content-lg-end align-items-center responsive-parecer">
          <div class="rounded py-2 px-3 px-md-4 px-lg-5 text-white text-center button" [ngClass]="{
            'bg-success': parecer.status<2, 
            'bg-warning': parecer.status>1 && parecer.status<4, 
            'bg-danger': parecer.status>3
          }">{{ parecer.value }}</div>
        </div>
      </div>
    </div>
  </div>